module.exports = __webpack_public_path__ + "static/media/img13.6abfed13.png";